module.exports = __webpack_public_path__ + "static/img/news8.0c49439.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news8.png
// module id = G8VV
// module chunks = 1